import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import {
    DocumentCsvIcon,
    DocumentDocIcon,
    DocumentExcelIcon,
    DocumentTextIcon,
} from '../assets/documentIcons';

const UserGeneratedMessage = ({ text, iconType }) => {
    const theme = useTheme();

    const renderIcon = () => {
        switch (iconType) {
            case 'Excel':
                return <DocumentExcelIcon width={80} height={80} style={{ marginRight: 8 }} />;
            case 'Word':
                return <DocumentDocIcon width={80} height={80} style={{ marginRight: 8 }} />;
            case 'CSV':
                return <DocumentCsvIcon width={80} height={80} style={{ marginRight: 8 }} />;
            case 'Text':
                return <DocumentTextIcon width={80} height={80} style={{ marginRight: 8 }} />;
            default:
                return null;
        }
    };

    const isDark = theme.palette.mode === 'dark';

    const backgroundGradient = isDark
        ? 'linear-gradient(to top, rgb(73, 71, 75), rgb(48, 45, 51))'
        : 'linear-gradient(to top, rgba(255, 255, 255, 0.8), rgba(0, 116, 211, 0.1))';

    const textColor = isDark ? theme.palette.grey[100] : theme.palette.text.primary;

    return (
        <Box
            sx={{
                padding: 2,
                marginTop: 1,
                marginBottom: 1,
                minHeight: 100,
                borderRadius: 1,
                boxShadow: 1,
                background: backgroundGradient,
                display: 'flex',
                alignItems: 'center',
            }}
        >
            {renderIcon()}
            <Typography
                variant="body1"
                sx={{
                    padding: 1,
                    color: textColor,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                }}
            >
                {text}
            </Typography>
        </Box>
    );
};

export default UserGeneratedMessage;
